import { useState } from "react";

export default function Consulta() {
    const [cuit, setCuit] = useState("");
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const buscar = async () => {
        if (!cuit) {
            setError("Por favor ingrese un CUIT");
            return;
        }

        setLoading(true);
        setError(null);
        setData(null);

        try {
            const res = await fetch(`/api/consulta/${cuit}`);
            if (!res.ok) {
                throw new Error(`Error ${res.status}: No se encontraron datos`);
            }
            const result = await res.json();
            setData(result);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    };

    const formatFecha = (f) => {
        if (!f) return "-";
        if (f.length === 8) {
            return `${f.slice(0, 2)}/${f.slice(2, 4)}/${f.slice(4, 8)}`;
        }
        return f;
    };

    const clean = (t) => {
        if (t === null || t === undefined) return "-";
        const cleaned = String(t).trim();
        return cleaned || "-";
    };

    const obtenerRazonSocial = (data) => {
        if (!data) return "Sin datos";

        if (data.tur005?.razonSoc?.trim())
            return data.tur005.razonSoc.trim();

        if (data.tur003?.length > 0 && data.tur003[0].razonSoc?.trim())
            return data.tur003[0].razonSoc.trim();

        if (data.tur006?.denominacion?.trim())
            return data.tur006.denominacion.trim();

        if (data.tur007?.DenominacionP?.trim())
            return data.tur007.DenominacionP.trim();

        return "Razón social no informada";
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            buscar();
        }
    };

    return (
        <div className="container mt-4">
            <h3 className="mb-3">Consulta Integral IIBB</h3>

            <div className="input-group mb-3">
                <input
                    className="form-control"
                    placeholder="Ingrese CUIT (sin guiones)"
                    value={cuit}
                    onChange={e => setCuit(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
                <button
                    className="btn btn-primary"
                    onClick={buscar}
                    disabled={loading}
                >
                    {loading ? "Buscando..." : "Buscar"}
                </button>
            </div>

            {loading && (
                <div className="alert alert-info">
                    Consultando base de datos...
                </div>
            )}

            {error && (
                <div className="alert alert-danger">
                    {error}
                </div>
            )}

            {data && (
                <>
                    {/* RAZÓN SOCIAL */}
                    <div className="card mb-3 shadow-sm bg-light">
                        <div className="card-body">
                            <h5 className="card-title text-secondary">
                                Razón Social
                            </h5>
                            <strong className="fs-5">
                                {obtenerRazonSocial(data)}
                            </strong>
                        </div>
                    </div>

                    {/* ATM – IIBB MISIONES */}
                    {data.tur005 && (
                        <div className="card mb-4 shadow-sm">
                            <div className="card-header bg-info text-white">
                                ATM – IIBB (Misiones)
                            </div>
                            <div className="card-body">
                                <p className="mb-0">
                                    <strong>Razón Social:</strong>{" "}
                                    {clean(data.tur005.razonSoc)}
                                </p>
                            </div>
                        </div>
                    )}

                    {/* CABA */}
                    {data.tur003?.length > 0 && (
                        <div className="card mb-4 shadow-sm">
                            <div className="card-header bg-primary text-white">
                                AGIP – CABA
                            </div>
                            <div className="table-responsive">
                                <table className="table table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>Desde</th>
                                            <th>Hasta</th>
                                            <th>Tipo</th>
                                            <th>Perc</th>
                                            <th>Rete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.tur003.map((x, i) => (
                                            <tr key={i}>
                                                <td>{formatFecha(x.fecDesde)}</td>
                                                <td>{formatFecha(x.fecHasta)}</td>
                                                <td>{clean(x.tipo)}</td>
                                                <td>{clean(x.alicPerc)}</td>
                                                <td>{clean(x.alicRete)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* ARBA */}
                    {data.tur002?.length > 0 && (
                        <div className="card mb-4 shadow-sm">
                            <div className="card-header bg-warning text-dark">
                                ARBA – Buenos Aires
                            </div>
                            <div className="table-responsive">
                                <table className="table table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>Desde</th>
                                            <th>Hasta</th>
                                            <th>Tipo</th>
                                            <th>Perc</th>
                                            <th>Rete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.tur002.map((x, i) => (
                                            <tr key={i}>
                                                <td>{formatFecha(x.fecDesde)}</td>
                                                <td>{formatFecha(x.fecHasta)}</td>
                                                <td>{clean(x.tipo)}</td>
                                                <td>{clean(x.alicPerc)}</td>
                                                <td>{clean(x.alicRete)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* SALTA */}
                    {data.tur006 && (
                        <div className="card mb-4 shadow-sm">
                            <div className="card-header bg-danger text-white">
                                DGR – Salta
                            </div>
                            <div className="card-body">
                                <p><strong>Actividad:</strong> {clean(data.tur006.actividad)}</p>
                                <p><strong>Exentas:</strong> {clean(data.tur006.actividadExentas)}</p>
                                <p className="mb-0"><strong>No Retención:</strong> {clean(data.tur006.certificadoNoRetencion)}</p>
                            </div>
                        </div>
                    )}

                    {/* TUCUMAN */}
                    {data.tur007 && (
                        <div className="card mb-4 shadow-sm">
                            <div className="card-header bg-success text-white">
                                DGR – Tucumán
                            </div>
                            <div className="card-body">
                                <p><strong>Nombre:</strong> {clean(data.tur007.DenominacionP)}</p>
                                <p className="mb-0"><strong>Porcentaje:</strong> {clean(data.tur007.porcentaje)}</p>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}